import { ApiPath } from "enums";
import { Post } from "utils";

export const createLoan = async ({ ...body }) => {
  const res = await Post(`${ApiPath.Loan}`, body);
  return res.data;
};
